<template lang="html">
<section class="menuTem">
  <el-menu class="el-menu-vertical-demo" mode="vertical"
           background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
           :default-active="activeMenu"
           :collapse-transition="true" :unique-opened="true"
           width='180px'
           :collapse="isCollapse"
           @select="handleselect"
           router>
    <fragment  v-for="(routeItem1,indexItem1) in menuRouteList" :key="routeItem1.name">
      <!--一级菜单-->
      <el-submenu v-if="routeItem1.children && Jurisdiction(routeItem1)" :index="routeItem1.name" :key="routeItem1.name">
        <template slot="title">
          <i :class="routeItem1.meta.iconClass" v-if="routeItem1.meta.iconClass"></i>
          <!-- <i class="active" v-if="routeItem1.name===$route.meta.parentName && isCollapse" :style="'background-image:url('+routeItem1.meta.iconActive+')'"></i>
          <i class="normal" v-else :style="'background-image:url('+routeItem1.meta.icon+')'"></i> -->
          <span slot="title">{{routeItem1.name}}</span>
        </template>
        <fragment v-for="(routeItem2, indexItem2) in routeItem1.children" :key="routeItem2.name">
          <!-- 二级菜单 -->
          <el-submenu v-if="routeItem2.children && Jurisdiction(routeItem1)"
                      :index="routeItem2.name" :key="routeItem2.name">
            <el-menu-item :index="routeItem2.name" :route="routeItem2" :key="routeItem2.name">
              {{routeItem2.name}}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="!routeItem2.children && Jurisdiction(routeItem2)" :index="routeItem2.name" :route="routeItem2">
            <i :class="routeItem2.meta.iconClass" v-if="routeItem2.meta.iconClass"></i>
            <!-- <i class="active"  v-if="routeItem2.name===$route.name" :style="'background-image:url('+routeItem2.meta.iconActive+')'"></i>
            <i class="normal" v-else :style="'background-image:url('+routeItem2.meta.icon+')'"></i> -->
            <span slot="title">{{routeItem2.name}}</span>
          </el-menu-item>
          <!-- 二级菜单 -->
        </fragment>
      </el-submenu>
      <el-menu-item v-if="!routeItem1.children && Jurisdiction(routeItem1)" :index="routeItem1.name" :route="routeItem1">
        <i :class="routeItem1.meta.iconClass" v-if="routeItem1.meta.iconClass"></i>
        <!-- <i class="active" v-if="routeItem1.name===$route.meta.parentName" :style="'background-image:url('+routeItem1.meta.iconActive+')'"></i>
        <i class="normal" v-else :style="'background-image:url('+routeItem1.meta.icon+')'"></i> -->
        <span slot="title">{{routeItem1.name}}</span>
      </el-menu-item>
      <!--一级菜单-->
    </fragment>
  </el-menu>

</section>

</template>

<script>
export default {
  name: "menu.vue",
  data(){
    return{
      activeMenu: "",
      isCollapse: false,
      menuRouteList: [],
    }
  },
  inject: ["reload"], // 注入重载的功能（注入依赖）
  watch:{
    '$route':{
      deep:true,
      immediate:true,
      handler(now,old){
        // console.log(now,old,'menu.vue')
      //  解析token 获取用户信息
        this.activeMenu = this.$route.name;
      },
    }
  },
  created() {

  },
  mounted() {
    let list = this.$router.options.routes;
    let len = list.length;
    this.menuRouteList = []
    this.menuRouteList = list[len - 1].children;
  },
  methods:{
    handleselect(index,indexPath){
      // console.log(index,indexPath)
      this.reload() // 点击侧边栏重新载入页面
    },


    Jurisdiction(routeItem){
      // console.log(routeItem.meta.role,'routeItem');
      return this.$config.authorityJudge(routeItem.meta.role)
      // return this.$config.authorityJudge(routeItem.meta.role);
    },

  }
}
</script>

<style type="text/css" scoped>
.menuTem{
  height: 100%;
  background-color: #545c64;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width:180px;
}
.el-menu{
  border: none;
}
.el-menu.el-menu--collapse /deep/ .el-submenu.is-active .el-submenu__title {}

.el-menu /deep/ .el-menu-item{}


.el-aside .el-menu .el-submenu .el-menu-item{
  min-width: 180px;
}


.el-menu /deep/ .el-menu-item.is-active{
  /*background-color: #F9FAFE !important;*/
  /*background-color: rgb(67,74,80) !important;*/
}
.el-menu /deep/ .el-submenu__title:hover{}
.el-menu /deep/ .el-menu-item:hover{}

.el-menu /deep/ .el-submenu__title{}

/*******整体处理菜单的图标*******/
.el-menu i{
  /*width: 24px;*/
  /*height: 24px;*/
  /*font-size: 18px;*/
  display: inline-block;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-right: 8px;
}
.el-menu i {
  width: 18px;
  height: 18px;
  font-size: 18px;
}
.el-menu .fa {
  vertical-align: middle;
  width: 18px;
  margin-right: 5px;
  height: 18px;
  text-align: center;
  font-size: 18px;
}
/*******整体处理菜单的图标*******/

</style>